import React from 'react';
import './App.css';
import { Anchor, Box, Main, Text } from 'grommet';
import {
    Outlet,
    redirect,
    useLoaderData,
    useNavigate,
    useParams,
} from 'react-router-dom';
import {
    clearUserData,
    hasToken,
    hasUserId,
    UserService,
    AppConstants,
} from '@enrich/shared-lib';

export const App = () => {
    const navigate = useNavigate();
    const { schoolSlug } = useParams();
    const user = useLoaderData();

    const logout = () => {
        clearUserData();
        navigate(`/${schoolSlug}/login`);
    };

    return (
        <Main>
            <Box
                align="center"
                background="enrich-blue"
                direction="row"
                justify="between"
                pad={{ top: 'large', bottom: 'medium', horizontal: 'large' }}>
                <Text>Enrich Scholars</Text>
                <Text weight="bold">
                    {user?.school?.name || schoolSlug}
                </Text>
            </Box>
            <Box
                background="enrich-grey"
                pad={{ vertical: 'small', horizontal: 'medium' }}
                direction="row"
                gap="medium"
                justify="between">
                <Box direction="row" gap="medium">
                    <Anchor
                        href={`/${schoolSlug}/dashboard`}
                        label="Dashboard"
                    />
                    <Anchor href={`/${schoolSlug}/students`} label="Students" />
                    <Anchor
                        href={`/${schoolSlug}/non-active`}
                        label="Non-Active Students"
                    />
                    <Anchor
                        href={`/${schoolSlug}/alumni`}
                        label="Alumni"
                    />
                    <Anchor
                        href={`/${schoolSlug}/companies`}
                        label="Companies"
                    />
                </Box>
                <Anchor onClick={logout} label="Log out" />
            </Box>

            <Outlet context={user} />
        </Main>
    );
};

export async function loader({ params }) {
    const { schoolSlug } = params;

    if (!hasToken() || !hasUserId()) {
        clearUserData();
        return redirect(`/${schoolSlug}/login`);
    }

    const userId = localStorage.getItem(AppConstants.cacheKeys.userId);
    try {
        const user = await new UserService().getUser(userId);

        const userSchoolSlug = user?.school?.slug;
        if (!userSchoolSlug || userSchoolSlug !== schoolSlug) {
            clearUserData();
            return redirect(`/${schoolSlug}/login`);
        }

        if (!user.tempPasswordChanged) {
            return redirect(`/${schoolSlug}/change-password`);
        }

        return user;
    } catch {
        clearUserData();
        return redirect(`/${schoolSlug}/login`);
    }
}
